import React, { useState, useEffect } from "react";
import { Menu, Button, Image, Grid } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import "../styles/OrganisationsNavbar.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganisations } from "../actions/adminConsoleAction";

const OrganisationsNavbar = ({
    setToggle,
    navTitle,
    type,
    NavbarCollapse,
    handleOpenOrganisationAdd,
    showOrganizatonCount,
    setFilteredOrganisations,
}) => {
    const navBarTitle = navTitle || "Q&A";
    const [inputValue, setInputValue] = useState("");

    const dispatch = useDispatch();
    const { organisations, loading, error } = useSelector((state) => state.admin);

    useEffect(() => {
        dispatch(fetchOrganisations());
    }, [dispatch]);

    useEffect(() => {
        setFilteredOrganisations(organisations);
    }, [organisations, setFilteredOrganisations]);

    const handleInputChange = (event) => {
        const value = event.target.value.toLowerCase();
        setInputValue(value);
        filterOrganisations(value);
    };

    const filterOrganisations = (searchTerm) => {
        if (searchTerm === "") {
            setFilteredOrganisations(organisations);
        } else {
            const filtered = organisations.filter(org =>
                org.orgName && org.orgName.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredOrganisations(filtered);
        }
    };

    const navigate = useNavigate();

    const handleBack = async () => {
        navigate(`/dataconsole`);
    };

    return (
        <Menu fixed="top" className="navbar" borderless style={{ zIndex: "0" }}>
            <Menu.Menu className={`${!NavbarCollapse ? "" : "navbar-collapse"}`}>
                {/* Mobile View and desktop view */}
                {!NavbarCollapse ? (
                    <Grid>
                        <React.Fragment>
                            <Menu.Item className="menu-item-left">
                                {/* Mobile view */}
                                <div onClick={setToggle} className="mobile-sidebar-icon">
                                    <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                                </div>
                                {/* Mobile view end */}
                                {type === "organisations_console" && (
                                    <>
                                        <Image src="/images/all-users.svg" alt="Data Console" />
                                    </>
                                )}
                                <label>{navBarTitle || "Default"}</label>
                            </Menu.Item>
                        </React.Fragment>
                        {type === "organisations_console" && (
                            <>
                               <Menu.Item className="menu-item-organisation">
                  <div className="tag">{showOrganizatonCount || 0} Organization</div>
                        </Menu.Item>
                                <Menu.Item>
                                    <div className="menu-item-search">
                                        <input
                                            type="text"
                                            id="landingSearchMobile"
                                            value={inputValue}
                                            onChange={handleInputChange}
                                            placeholder=" "
                                            data-cy="organisation-search-input"
                                            autoComplete="off" // Disable autocomplete
                                        />
                                        <label htmlFor="landingSearchMobile">
                                            <img src="/images/search.svg" alt="Logo" />
                                            Search
                                        </label>
                                    </div>
                                    {NavbarCollapse}
                                </Menu.Item>
                            </>
                        )}
                    </Grid>
                ) : (
                    <Grid>
                        <React.Fragment>
                            <Menu.Item className="menu-item-left">
                                {/* Mobile view */}
                                <div onClick={setToggle} className="mobile-sidebar-icon">
                                    <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                                </div>
                                {/* Mobile view end */}
                                {type === "organisations_console" && (
                                    <>
                                        <Image src="/images/all-users.svg" alt="Data Console" />
                                    </>
                                )}
                                <label>
                                    {navBarTitle.length < 25
                                        ? navBarTitle
                                        : navBarTitle.slice(0, 24) + "..." || "Default"}
                                </label>
                            </Menu.Item>
                        </React.Fragment>
                        {/*Desktop landing Page */}
                        {type === "organisations_console" && (
                            <>
                            <Menu.Item className="menu-item-data-consoles">
                  <div className="tag">{organisations.length} Organizations</div>
                </Menu.Item>
                                <Menu.Item>
                                    <div className="menu-item-search">
                                        <input
                                            type="text"
                                            id="landingSearchDesktop"
                                            value={inputValue}
                                            onChange={handleInputChange}
                                            placeholder=""
                                            data-cy="organisation-search-input"
                                            autoComplete="off" // Disable autocomplete
                                        />
                                        <label htmlFor="landingSearchDesktop">
                                            <img src="/images/search.svg" alt="Logo" />
                                            Search
                                        </label>
                                    </div>
                                    {NavbarCollapse}
                                </Menu.Item>
                            </>
                        )}
                    </Grid>
                )}
            </Menu.Menu>

            {/* Right-aligned content */}
            <Menu.Menu position="right">
                <React.Fragment>
                    {type === "organisations_console" && (
                        <Menu.Item className="hide-add-dataset-button-desktop">
                            <Button
                                primary
                                onClick={handleOpenOrganisationAdd}
                                className="button-data-console"
                                data-cy="add-organisation-btn-link"
                            >
                                <div className="button-data-console-parent">
                                    <Image
                                        src="/images/white-base-icons.svg"
                                        alt="Add new Organisation"
                                    />
                                    Create new organization
                                </div>
                            </Button>
                        </Menu.Item>
                    )}
                </React.Fragment>
            </Menu.Menu>
        </Menu>
    );
};

export default OrganisationsNavbar;
